export const sortedRendReasonsValues = values => {
	return values.sort((a, b) => a.name.localeCompare(b.name));
};
